import { FieldMappings } from '../organisation-settings/components/field-mappings';
import { Breadcrumb } from '@/new/components/breadcrumb';
import { PageContainer } from '@/new/components/page-container';
import { PageHeader } from '@/new/components/page-header';
import { PageTitle } from '@/new/components/page-title';

export function FieldMappingsPage() {
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <Breadcrumb
        items={[
          { href: '/organisation-settings/integrations', label: 'Organisation Settings', active: false },
          { href: '/organisation-settings/integrations', label: 'Relativity Integration', active: false },
          { href: '/relativity/field-mappings', label: 'Field Mappings', active: true },
        ]}
      />
      <PageContainer className="flex min-h-0 flex-1 flex-col">
        <PageHeader>
          <PageTitle text="Relativity Field Mappings" subtext="Import file metadata from your Relativity workspaces." />
        </PageHeader>
        <FieldMappings />
      </PageContainer>
    </div>
  );
}
